import React from 'react';
import Button from 'material-ui/Button';
import Grid from 'material-ui/Grid';
import Typography from 'material-ui/Typography';

const LandingPage = () =>
  <div>
    <Grid container>
      <Grid sm={6}>
      </Grid>
      <Grid sm={6}>
        <Typography variant="display3">SeCo.ai - Security Controls intelligence</Typography>
      </Grid>
    </Grid>
    <Grid container>
      <Grid sm={2}>
        <Button variant="raised" color="primary" >
            Sign-in
        </Button>
      </Grid>
      <Grid sm={2}>
        <Button color="secondary" >
            Sign-up
        </Button>
      </Grid>
    </Grid>
  </div>

export default LandingPage;


// WEBPACK FOOTER //
// ./src/components/Landing.js